import { i18n } from 'localization'
import { parseDate, parsePerson } from './utils'
import { LinkedElementType } from 'utils/enums'
export default class Comment {
	static fromJSON(json) {
		return new Comment(json.id)
			.withType(json.type)
			.withTitle(json.title)
			.withBody(json.body)
			.withDate(json.creationDate)
			.withAuthor(json.author)
			.withEstablishment(json.providerEstablishment)
			.withManagementEntity(json.providerEstablishment)
			.withEntity(json.author?.entity)
			.withAttachments(json.file)
			.withRepliesCount(json.repliesCount)
			.withProcessId(json.processId)
			.withLinkedElement(json.linkedElementType, json.linkedElementId)
			.withPinned(json.pinned)
			.withNotifiedEstablishments(json.notifiedEstablishments)
			.withNotifiedEntities(json.notifiedEntities)
			.withLatestUpdateDate(json.latestUpdateDate)
	}

	constructor(id) {
		this.id = id
		this.key = `comment_${id || ''}`
		this.textId = `comment_${id || ''}`
	}

	withTitle(title) {
		this.title = i18n.translate(title || '')
		return this
	}
	withType(type) {
		this.type = type
		return this
	}
	withBody(body) {
		this.body = body?.replace(/<br\/>/gi, '\r\n')
		this.text = this.body
		return this
	}
	withDate(dateStr) {
		if (dateStr) {
			this.date = parseDate(dateStr)
		} else {
			this.date = {}
		}
		return this
	}

	withAuthor(json) {
		this.author = json ? parsePerson(json) : null
		return this
	}

	withEstablishment(providerEstablishment) {
		this.providerEstablishment = providerEstablishment
		return this
	}

	withManagementEntity(providerEstablishment) {
		this.managementEntity =
			providerEstablishment?.id === 1
				? true
				: providerEstablishment?.name?.toLowerCase().includes('trust')
		return this
	}

	withEntity(json) {
		this.entity = json?.name || ''
		return this
	}

	withAttachments(json) {
		if (json) {
			this.files = [json]
			this.filesOptions = this.files.map(() => ({
				id: json.id,
				name: json.name,
				value: json.id,
				text: json.name,
			}))
			this.hasFiles = true
		}
		return this
	}

	withRepliesCount(json) {
		this.repliesCount = json
		return this
	}

	withProcessId(json) {
		this.processId = json

		return this
	}

	withLinkedElement(elementType, elementId) {
		if (elementType && elementId) {
			this.linkedTo = {
				text: i18n.translate(
					elementType === LinkedElementType.Appointment
						? 'Appointment'
						: 'Requisition'
				),
				id: elementId,
				type: elementType,
			}
		}

		return this
	}

	withPinned(pinned) {
		this.isPinned = pinned ? true : false

		return this
	}

	withNotifiedEstablishments(establishments) {
		this.notifiedEstablishments = establishments ?? []

		return this
	}

	withNotifiedEntities(entities) {
		this.notifiedEntities = entities ?? []

		return this
	}

	withLatestUpdateDate(latestUpdate) {
		this.latestUpdateDate = parseDate(latestUpdate)

		return this
	}
}
